// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-no-content {
  position: relative;
  height: 376px;
  width: 100%;
  padding-top: 15px;
}
.container-no-content > .wait-content {
  position: absolute;
  top: 5px;
  left: 0;
  width: 100%;
  text-align: center;
  font-family: var(--font);
  font-weight: 600;
  font-size: 1.3rem;
}
.container-no-content ion-icon {
  height: 300px;
  width: 100%;
}
.container-no-content .text-empty-content {
  height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin: auto;
  text-align: center;
  font-family: var(--font);
}
.container-no-content .text-empty-content .title {
  font-weight: 600;
  font-size: 17px;
  margin-bottom: 10px;
}

.item-page:last-child {
  border-bottom: none;
}

.icon {
  font-size: 2.4em;
  margin: auto;
}

.custom-icon-img {
  width: 35px;
  height: 35px;
}

.item-page {
  border-bottom: 1px solid;
}
.item-page ion-avatar {
  width: 78px;
  height: 98px;
  margin: 15px;
  display: flex;
  border: 1px solid;
  border-color: rgb(160, 160, 160);
}
.item-page ion-avatar ion-icon {
  width: 22px;
  height: 22px;
  margin: auto;
  border-radius: 0;
}
.item-page ion-label {
  height: 48px;
  display: flex;
  align-items: center;
}
.item-page ion-label h2 {
  font-family: var(--font);
  font-weight: 600;
}
.item-page ion-label p {
  font-family: var(--font);
  font-weight: 300;
  font-size: 12px;
}

ion-avatar {
  --border-radius: 4px;
}

.no-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;
  color: #6c757d;
  padding: 20px;
}
.no-content ion-icon {
  font-size: 48px;
  margin-bottom: 10px;
  height: 64px;
  width: 64px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/custom-pages/custom-pages.page.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;AACJ;AAAI;EACI,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,iBAAA;AAGR;AADI;EACI,aAAA;EACA,WAAA;AAGR;AADI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;AAGR;AAFQ;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;AAIZ;;AAAA;EACI,mBAAA;AAGJ;;AADA;EACI,gBAAA;EACA,YAAA;AAIJ;;AAFA;EACI,WAAA;EACA,YAAA;AAKJ;;AAHA;EAEI,wBAAA;AAKJ;AAJI;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,gCAAA;AAMR;AALQ;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAOZ;AAJI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;AAMR;AALQ;EACI,wBAAA;EAA0B,gBAAA;AAQtC;AANQ;EACI,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;AASZ;;AALA;EACI,oBAAA;AAQJ;;AALA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;AAQF;AANE;EACE,eAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAQJ","sourcesContent":[".container-no-content{\n    position: relative;\n    height: 376px;\n    width: 100%;\n    padding-top: 15px;\n    >.wait-content{\n        position: absolute;\n        top: 5px;\n        left: 0;\n        width: 100%;\n        text-align: center;\n        font-family: var(--font); font-weight: 600;;\n        font-size: 1.3rem;\n    }\n    ion-icon{\n        height: 300px;\n        width: 100%;\n    }\n    .text-empty-content {\n        height: 70px;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-around;\n        margin: auto;\n        text-align: center;\n        font-family: var(--font);\n        .title{ \n            font-weight: 600;\n            font-size: 17px;\n            margin-bottom: 10px;\n        }\n    }\n}\n.item-page:last-child {\n    border-bottom: none;\n}\n.icon{\n    font-size: 2.4em;\n    margin: auto;\n}\n.custom-icon-img{\n    width: 35px;\n    height: 35px;\n}\n.item-page{\n    //--detail-icon-color: var(--text-color-2nd-login-desktop);\n    border-bottom: 1px solid ;\n    ion-avatar{\n        width: 78px;\n        height: 98px;\n        margin: 15px;\n        display: flex;\n        border: 1px solid;\n        border-color: rgb(160, 160, 160);\n        ion-icon {\n            width: 22px;\n            height: 22px;\n            margin: auto;\n            border-radius: 0;\n        }\n    }\n    ion-label{\n        height: 48px;\n        display: flex;\n        align-items: center;\n        h2{\n            font-family: var(--font); font-weight: 600;;\n        }\n        p{\n            font-family: var(--font); font-weight: 300;;\n            font-size: 12px;\n        }\n    }\n}\nion-avatar{\n    --border-radius: 4px;\n}\n\n.no-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  text-align: center;\n  color: #6c757d;\n  padding: 20px;\n\n  ion-icon {\n    font-size: 48px; \n    margin-bottom: 10px; \n    height: 64px; \n    width: 64px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
